import { render, staticRenderFns } from "./FamCustom.vue?vue&type=template&id=3ba0f586&scoped=true&"
import script from "./FamCustom.vue?vue&type=script&lang=js&"
export * from "./FamCustom.vue?vue&type=script&lang=js&"
import style0 from "./FamCustom.vue?vue&type=style&index=0&id=3ba0f586&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba0f586",
  null
  
)

component.options.__file = "FamCustom.vue"
export default component.exports